export type OtsAnchorRect = {
  left: number;
  top: number;
  width: number;
  height: number;
};
export type OtsViewportRect = OtsAnchorRect;
export type OtsFloatingPlacement =
  | 'bottom start'
  | 'bottom end'
  | 'top start'
  | 'top end';

/** Client coordinates, including visual-viewport offsets when the page is zoomed. */
export function positionOtsFloatingPanel(
  anchor: OtsAnchorRect,
  panel: { width: number; height: number },
  viewport: OtsViewportRect,
  placement: OtsFloatingPlacement = 'bottom start',
  margin = 8,
  gap = 6
) {
  const minX = viewport.left + margin;
  const minY = viewport.top + margin;
  const maxX = Math.max(minX, viewport.left + viewport.width - margin);
  const maxY = Math.max(minY, viewport.top + viewport.height - margin);
  const width = Math.min(panel.width, Math.max(0, maxX - minX));
  const bottom = Math.min(
    maxY,
    Math.max(minY, anchor.top + anchor.height + gap)
  );
  const top = Math.min(maxY, Math.max(minY, anchor.top - gap));
  const below = maxY - bottom;
  const above = top - minY;
  const preferAbove = placement.startsWith('top');
  const fits = panel.height <= (preferAbove ? above : below);
  const useAbove = fits
    ? preferAbove
    : above === below
    ? preferAbove
    : above > below;
  const maxHeight = Math.max(0, useAbove ? above : below);
  const height = Math.min(panel.height, maxHeight);
  const preferredLeft = placement.endsWith('end')
    ? anchor.left + anchor.width - width
    : anchor.left;
  return {
    left: Math.max(minX, Math.min(preferredLeft, maxX - width)),
    top: useAbove ? top - height : bottom,
    maxWidth: Math.max(0, maxX - minX),
    maxHeight,
  };
}
